module.exports = __webpack_public_path__ + "static/media/CogniableLogo.987b9995.jpeg";